// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiUrl: 'https://6h6u6sn5mc.execute-api.eu-central-1.amazonaws.com/dev',
    publicApiUrl: 'https://ioa3wg0xbe.execute-api.eu-central-1.amazonaws.com/dev',
    cognito: {
        userPoolId: 'eu-central-1_QDgjzYUj8',
        userPoolWebClientId: '35fhbsqjeogin3u7tukvmhi4ap',
        mandatorySignIn: true
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
